//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { flow } from "mobx";
import {
  applySnapshot,
  cast,
  getParent,
  getSnapshot,
  types,
} from "mobx-state-tree";
import { UploadStore } from "./upload-store";
import { STEPS } from "./utils";
const Proof = types
  .model("Proof", {
    id: types.optional(types.string, ""),
    url: types.optional(types.string, ""),
  })
  .actions((self) => {
    return {
      updateFields(value) {
        self.id = value.id;
        self.url = value.url;
      },
    };
  });
const NewUploadStore = types
  .model("UploadStore", {
    instance: types.optional(UploadStore, {}),
  })
  .views((self) => {
    return {
      get files() {
        return self.instance.files;
      },
      onDeleteFile(index: any) {
        return self.instance.onDeleteFile(index);
      },
      get isUploading() {
        return self.instance.isUploading;
      },
      get percent() {
        return self.instance.percent;
      },
      get rawFiles() {
        return self.instance.files;
      },
    };
  })
  .actions((self) => {
    const parent: any = getParent(self, 1);
    const onDrop = flow(function* onUpload(files, progressCallBack) {
      try {
        yield self.instance.onDrop(files, progressCallBack);
        let instance = self.instance.files[0];
        parent.updateProof({ id: instance.public_id, url: instance.url });
      } catch (error) {
        console.log(error);
      }
    });
    return {
      onDrop,
    };
  });

const WorkHistoryStore = types
  .model("WorkHistoryStore", {
    company: types.optional(types.string, ""),
    role: types.optional(types.string, ""),
    isTeachingRole: types.optional(types.boolean, false),
    startYear: types.optional(types.string, ""),
    endYear: types.optional(types.string, ""),
    isCurrent: types.optional(types.boolean, false),
    showOnProfile: types.optional(types.boolean, true),
    upload: types.optional(NewUploadStore, {}),
    proof: types.optional(Proof, {}),
  })
  .views((self) => {
    return {
      get formValues() {
        let { upload, proof, ...rest } = self;
        return { ...rest, proof: getSnapshot(proof) };
      },
    };
  })
  .actions((self) => {
    const updateProof = flow(function* uploadProof(value) {
      const parent: any = getParent(self, 3);
      self.proof.updateFields(value);
      yield parent.onFormSubmit({}, STEPS.WORK_HISTORY);
    });
    return {
      updateProof,
      updateFields(data) {
        applySnapshot(self, { ...getSnapshot(self), ...data });
      },
      initializeUploadStore() {
        if (self.proof.id) {
          self.upload.instance.files = cast([
            {
              public_id: self.proof.id,
              url: self.proof.url,
            },
          ]);
        }
      },
    };
  });

const EducationStore = types
  .model("EducationStore", {
    school: types.optional(types.string, ""),
    country: types.optional(types.string, "Nigeria"),
    course: types.optional(types.string, ""),
    degree: types.optional(types.string, ""),
    speciality: types.optional(types.string, ""),
    startYear: types.optional(types.string, ""),
    endYear: types.optional(types.string, ""),
    grade: types.optional(types.string, ""),
    upload: types.optional(NewUploadStore, {}),
    proof: types.optional(Proof, {}),
  })
  .views((self) => {
    return {
      get formValues() {
        let { upload, proof, ...rest } = self;
        return { ...rest, proof: getSnapshot(proof) };
      },
    };
  })
  .actions((self) => {
    const updateProof = flow(function* uploadProof(value) {
      const parent: any = getParent(self, 3);
      self.proof.updateFields(value);
      yield parent.onFormSubmit({}, STEPS.EDUCATION_HISTORY);
    });
    return {
      updateProof,
      updateFields(data) {
        applySnapshot(self, { ...getSnapshot(self), ...data });
      },
      initializeUploadStore() {
        if (self.proof.id) {
          self.upload.instance.files = cast([
            {
              public_id: self.proof.id,
              url: self.proof.url,
            },
          ]);
        }
      },
    };
  });

const CertificationStore = types
  .model("CertificationStore", {
    name: types.optional(types.string, ""),
    institution: types.optional(types.string, ""),
  })
  .actions((self) => {
    return {
      updateFields(data) {
        applySnapshot(self, { ...getSnapshot(self), ...data });
      },
    };
  });

const GuarantorStore = types
  .model("GuarantorStore", {
    title: types.optional(types.maybeNull(types.string), ""),
    fullName: types.optional(types.maybeNull(types.string), ""),
    email: types.optional(types.maybeNull(types.string), ""),
    occupation: types.optional(types.maybeNull(types.string), ""),
    phone: types.optional(types.maybeNull(types.string), ""),
    company: types.optional(types.maybeNull(types.string), ""),
    relationship: types.optional(types.maybeNull(types.string), ""),
    no_of_years: types.optional(types.maybeNull(types.string), ""),
  })
  .actions((self) => {
    return {
      updateFields(data) {
        applySnapshot(self, { ...getSnapshot(self), ...data });
      },
    };
  });

export type SEducationHistoryType = {
  educations: Array<{
    school: string;
    country: string;
    course: string;
    degree: string;
    startYear: string;
    endYear: string;
    grade: string;
  }>;
  workHistories: Array<{
    company: string;
    role: string;
    isTeachingRole: boolean;
    startYear: string;
    endYear: string;
    isCurrent: boolean;
    showOnProfile: boolean;
  }>;
  guarantors: Array<{
    title: string;
    fullName: string;
    email: string;
    occupation: string;
    phone: string;
    company: string;
    relationship: string;
  }>;
  certifcations: Array<{
    name: string;
    institution: string;
  }>;
};
const Degree = types
  .model("Degree", {
    name: types.string,
    abbrev: types.string,
    rank: types.optional(types.union(types.number, types.string), ""),
    factor: types.optional(types.number, 1),
  })
  .views((self) => {
    return {
      get rank_as_number() {
        if (Number.isInteger(self.rank)) {
          return self.rank;
        }
        return parseInt(self.rank as string);
      },
    };
  });
export const EducationData = types.model("EducationData", {
  degree_data: types.optional(types.array(Degree), []),
  grade_data: types.optional(types.array(types.string), []),
  specialities: types.optional(types.array(types.string), []),
  languages: types.optional(types.array(types.string), []),
  sources: types.optional(types.array(types.string), []),
});

export const EducationWorkHistoryStore = types
  .model("EducationWorkHistoryStore", {
    educations: types.optional(types.array(EducationStore), []),
    currentEducationIndex: types.optional(types.number, -1),
    workHistories: types.optional(types.array(WorkHistoryStore), []),
    currentWorkHistoryIndex: types.optional(types.number, -1),
    guarantors: types.optional(types.array(GuarantorStore), []),
    currentGuarantorIndex: types.optional(types.number, -1),
    certifications: types.optional(types.array(CertificationStore), []),
    certificationIndex: types.optional(types.number, -1),
    canSave: types.optional(types.boolean, false),
    data: types.optional(EducationData, {}),
  })
  .views((self) => {
    return {
      get completed(): boolean {
        let value: any = self;
        return (
          value.educationCompleted &&
          value.workCompleted &&
          value.guarantorsCompleted
        );
      },
      get educationCompleted() {
        let condition1 = self.educations.length > 0;
        let condition2 = self.educations.every((i: any) => {
          return Object.keys(i).every((j) => Boolean(i[j]));
        });
        return condition1;
        // return condition1 && condition2;
      },
      get workCompleted() {
        let condition1 = self.workHistories.length > 0;
        return condition1;
      },
      get guarantorsCompleted() {
        let condition1 = self.guarantors.length >= 2;
        let condition2 = self.guarantors.every((i: any) => {
          return Object.keys(i).every((j) => Boolean(i[j]));
        });
        return condition1;
        // return condition1 && condition2;
      },
      get formValues(): SEducationHistoryType {
        let result: any = {
          educations: self.educations.map((o) => o.formValues),
          workHistories: self.workHistories.map((o) => o.formValues),
          guarantors: getSnapshot(self.guarantors),
          certifications: getSnapshot(self.certifications),
        };
        return result;
      },

      get maxEducationFactor() {
        const userDegrees = self.educations.map(({ degree }) => degree);
        const factors: number[] = [];
        self.data.degree_data.forEach(({ abbrev, factor }) => {
          if (userDegrees.includes(abbrev)) {
            factors.push(factor);
          }
        });
        return Math.max(0, ...factors);
      },
      // get totalWorkExperience(){
      //     let teachingWorkHistory = self.workHistory.filter(
      //       workHistory => workHistory.isTeachingRole
      //     );
      get totalWorkExperience() {
        let teachingWorkHistory = self.workHistories.filter(
          (workHistory) => workHistory.isTeachingRole,
        );

        const workReducer = (accumulator, currentValue) => {
          if (currentValue.isCurrent) {
            let today = new Date();
            let diffInYears =
              today.getFullYear() - parseInt(currentValue.startYear);
            return accumulator + diffInYears;
          }

          if (currentValue.endYear === currentValue.startYear) {
            let diffInYears =
              parseInt(currentValue.endYear) -
              parseInt(currentValue.startYear) +
              1;
            return accumulator + diffInYears;
          }

          let diffInYears =
            parseInt(currentValue.endYear) - parseInt(currentValue.startYear);
          return accumulator + diffInYears;
        };

        let experience = teachingWorkHistory.reduce(workReducer, 0);
        return experience;
      },
      // get highestEducation(){
      //   let highestEducation = tutorData.education[0];
      //   let degree = DEGREE_DATA.find(
      //     data => data.abbrev === highestEducation.degree
      //   );
      //   if (degree !== undefined) return degree.rank;
      //   return 1;
      // }
    };
  })
  .actions((self) => {
    function saveHelper(data: any, currentIndex: any, key: any) {
      let dataToSave: any = undefined;
      try {
        dataToSave = data;
      } catch (error) {
        dataToSave = data;
      }
      if (currentIndex < 0) {
        self[key].push(dataToSave);
      } else {
        // let oldData: any = getSnapshot(self[key]);
        self[key][currentIndex].updateFields(dataToSave);
        // const results = oldData.map((x: any, i: any) => {
        //   if (i === currentIndex) {
        //     return dataToSave;
        //   }
        //   return x;
        // });
        // self[key] = results;
      }
    }
    return {
      editWorkHistory(index: number) {
        self.currentWorkHistoryIndex = index;
      },
      editEducation(index: number) {
        self.currentEducationIndex = index;
      },
      editCertification(index: number) {
        self.certificationIndex = index;
      },
      addWorkHistory() {
        self.currentWorkHistoryIndex = -1;
      },
      addEducation() {
        self.currentEducationIndex = -1;
      },
      addCertification() {
        self.certificationIndex = -1;
      },
      updateEducationData(data: any) {
        applySnapshot(self.data, data);
        // update
      },
      removeWorkHistory() {
        if (self.currentWorkHistoryIndex > -1) {
          self.workHistories = cast(
            self.workHistories.filter(
              (x: any, i: any) => i !== self.currentWorkHistoryIndex,
            ),
          );
        }
        self.currentWorkHistoryIndex = -1;
      },
      removeEducation() {
        if (self.currentEducationIndex > -1) {
          self.educations = cast(
            self.educations.filter(
              (x: any, i: any) => i !== self.currentEducationIndex,
            ),
          );
        }
        self.currentEducationIndex = -1;
      },
      removeCertification() {
        if (self.certificationIndex > -1) {
          self.certifications = cast(
            self.certifications.filter(
              (x: any, i: any) => i !== self.certificationIndex,
            ),
          );
        }
        self.certificationIndex = -1;
      },

      saveEducation(data: any) {
        saveHelper(data, self.currentEducationIndex, "educations");
      },
      saveWorkHistory(data: any) {
        saveHelper(data, self.currentWorkHistoryIndex, "workHistories");
      },
      saveCertification(data: any) {
        saveHelper(data, self.certificationIndex, "certifications");
      },
      editGuarantor(index: any) {
        self.currentGuarantorIndex = index;
      },
      resetCanSave() {
        self.canSave = false;
      },
      addGuarantor() {
        self.currentGuarantorIndex = -1;
      },
      removeGuarantor() {
        if (self.currentGuarantorIndex > -1) {
          self.guarantors = cast(
            self.guarantors.filter(
              (x: any, i: any) => i !== self.currentGuarantorIndex,
            ),
          );
        }
        self.currentGuarantorIndex = -1;
      },
      saveGuarantor(data: any) {
        saveHelper(data, self.currentGuarantorIndex, "guarantors");
      },

      initializeUploadStore() {
        self.educations.forEach((education) =>
          education.initializeUploadStore(),
        );
        self.workHistories.forEach((history) =>
          history.initializeUploadStore(),
        );
      },
    };
  });
